<template>
  <div class="wrap" style="layout-grid: 15.6pt">
    <div>
      <p class="normal" v-for="(item, index) in headData" :key="index">
        <span>{{ item.txt }}</span>
        <template v-if="item.data">
          <p class="sub_norma" v-for="(it, i) in item.data" :key="index + '-' + i">
            <a v-if="it.href" :href="it.href">
              <span>{{ it.txt }}</span>
            </a>
            <span v-else>{{ it.txt }}</span>
          </p>
        </template>
      </p>
    </div>
    <div v-for="(item, index) in data" :key="index">
      <h3 v-if="item.title">{{ item.title }}</h3>
      <div v-for="(it, i) in item.data" :key="index + '-' + i">
        <p class="normal">
          <span>{{ it.txt }}</span>
          <b>{{ it.btxt }}</b>
        </p>
        <template v-if="it.tips">
          <p v-for="(tip, idx) in it.tips" :key="index + '-' + i + '-' + idx" class="sub_norma">
            <span>
              <span v-if="it.tips.length > 1">({{ idx + 1 }})</span>
              <span v-if="tip.utxt">
                <span v-for="(uitem, uidx) in tip.utxt" :key="'u' + uidx">
                  <span v-if="uidx % 2 === 0">{{ uitem }}</span>
                  <u v-else>{{ uitem }}</u>
                </span>
              </span>
              <span v-else>
                {{ tip.txt }}
              </span>
            </span>
            <template v-if="tip.tips">
              <p v-for="(ttip, iidx) in tip.tips" :key="idx + '~' + iidx">
                <span class="sub_norma_tip" v-if="ttip.txt">
                  — {{ ttip.txt }}
                </span>
                <span class="sub_norma" v-else>
                  {{ ttip.btxt }}
                </span>
              </p>
            </template>
          </p>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        headData: [
            {
                txt: '欢迎使用“乐私塾”提供的产品和服务！本机构（或简称“我们”）深知个人信息对您的重要性，我们一向庄严承诺保护使用我们的产品和服务（以下统称“我们的产品和服务”）之用户（以下统称“用户”或“您”）的个人信息及隐私安全。您在使用我们的产品和服务时，我们可能会收集和使用您的相关个人信息（或简称“个人信息”）。我们希望通过本政策向您说明我们在收集和使用您相关个人信息时对应的处理规则，以及我们为您提供的访问、更正、删除和保护这些个人信息的方式，以便更好的保障您的权益。'
            },
            {
                txt: '本政策将帮助您了解以下内容：',
                data: [
                    {
                        txt: '一、我们如何收集和使用您的个人信息',
                        href: 'http://c.youdao.com/xue/legal.html#_%E4%B8%80%E3%80%81%E6%88%91%E4%BB%AC%E5%A6%82%E4%BD%95%E6%94%B6%E9%9B%86%E5%92%8C%E4%BD%BF%E7%94%A8%E4%BF%A1%E6%81%AF'
                    },
                    {
                        txt: '二、我们如何使用COOKIES或同类技术',
                        href: 'http://c.youdao.com/xue/legal.html#_%E4%B8%89%E3%80%81%E6%88%91%E4%BB%AC%E5%A6%82%E4%BD%95%E4%BD%BF%E7%94%A8COOKIES%E6%88%96%E5%90%8C%E7%B1%BB%E6%8A%80%E6%9C%AF_1'
                    },
                    {
                        txt: '三、我们可能分享、转让和披露的个人信息'
                    },
                    {
                        txt: '四、我们如何保留、储存和保护您的个人信息安全'
                    },
                    {
                        txt: '五、如何管理您的个人信息'
                    },
                    {
                        txt: '六、第三方服务'
                    },
                ],
            },
            {
                txt: '【特别提示】请您在使用我们的产品和服务前，仔细阅读并了解本政策（特别是加粗或下划线标注的内容），以做出适当选择。一旦您使用或在我们更新本政策后继续使用我们的产品或服务，即意味着您同意本政策并同意我们按照本政策处理您的相关个人信息。 '
            },
        ],
      data: [
        {
            title: '一、我们如何收集和使用您的个人信息',
            data: [
                {
                    txt: '我们收集您的个人信息主要是为了您和其他用户能够更容易和更满意地使用我们的产品和服务。而这些个人信息有助于我们实现这一目标。'
                },
                {
                    btxt: '※我们将通过以下途径收集和获得您的个人信息：',
                    tips: [
                        {
                            txt: '您提供的个人信息。',
                            tips: [
                                {
                                    txt: '您在注册我们的产品和服务的帐号或使用我们的产品和服务时，向我们提供的个人信息；'
                                },
                                {
                                    txt: '您通过我们的产品和服务向其他方提供的共享个人信息，以及您使用我们的产品和服务时所储存的个人信息。'
                                },
                                {
                                    btxt: '请注意，如您在我们的产品和服务中其他用户可见的公开区域内上传或发布的个人信息中、您对其他人上传或发布的信息作出的回应中公开您的个人信息，该等个人信息可能会被他人收集并加以使用。当您发现他人不正当地收集或使用您的个人信息时，您可以通过本政策第九条【如何联系我们】约定的联系方式联络我们。'
                                }
                            ]
                        },
                        {
                            txt: '其他方分享的您的个人信息。亦即其他方使用我们的产品和服务时所提供有关您的共享个人信息。'
                        },
                        {
                            txt: '我们获取的您的个人信息。您在使用我们的产品和服务时，我们收集、汇总、记录的个人信息。'
                        }
                    ]
                },
                {
                    btxt: '※我们会出于以下目的，收集和使用您以下类型的个人信息：',
                    tips: [
                        {
                            txt: '帮助您完成注册、登录',
                            tips: [
                                {
                                    txt: '为便于我们为您提供完整的我们的产品和服务，您需要提供基本注册或登录个人信息，包括使用手机号码注册登录或提供第三方账号登录乐私塾。如果您仅需使用浏览、搜索等基本服务，您不需要注册成为乐私塾用户及提供上述个人信息。'
                                },
                                {
                                    txt: '在我们的产品和服务注册、登录或后续使用过程中，如果您提供其他额外个人信息：您的昵称、头像、您的学习阶段，将有助于我们给您提供个性化的推荐和更优的服务体验，但如果您不提供这些个人信息，并不会影响您使用我们的产品和服务的基本功能。'
                                }
                            ]
                        },
                        {
                            txt: '实现身份认证',
                            tips: [
                                {
                                    txt: '依照相关法律法规规定及监管要求，或为满足用户身份真实核验、保障系统和服务安全及其他特定服务功能的需要，我们可能需要您提供真实身份信息（姓名、身份证、面部特征、指纹及其他身份信息）以完成身份认证。如果您不提供上述信息，我们将不能向您提供相关的功能及服务。'
                                },
                                {
                                    txt: '为实现身份认证的目的，您同意并授权我们可以自行或委托第三方向有关身份认证机构（如个人征信机构、政府部门等）提供、查询、核对您的前述身份信息。'
                                }
                            ]
                        }
                    ]
                },
                {
                    btxt: '※维护基础功能的正常运行',
                    tips: [
                        {
                            txt: '在您使用我们服务过程中，为识别账号异常状态、了解产品适配性，向您提供浏览、搜索等基本服务，维护基础功能的正常运行，我们可能会自动收集、储存关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：',
                            tips: [
                                {
                                    txt: '日志信息：当您使用我们的服务时，我们可能会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。日志信息包括您的登录账号、搜索查询内容、IP地址、浏览器的类型、电信运营商、网络环境、使用的语言、访问日期和时间及您访问的网页浏览记录、Push打开记录、崩溃记录、停留时长、刷新记录、发布记录、关注、订阅、收藏及分享。'
                                },
                                {
                                    txt: '设备信息：我们可能会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（包括IMEI、MAC、Serial、UUID、SIM卡IMSI识别码、设备机型、操作系统及版本、客户端版本、设备分辨率、包名、设备设置、进程及软件列表、唯一设备标识符、软硬件特征信息）、设备所在位置相关信息（包括IP 地址、GPS位置以及能够提供相关个人信息的WLAN接入点、蓝牙和基站传感器信息）。'
                                },
                                {
                                    btxt: '同时为了收集上述基本的个人设备信息，我们将会申请访问您的设备信息的权限，我们收集这些信息是为了向您提供我们基本服务和基础功能，如您拒绝提供上述权限将可能导致您无法使用我们的产品与服务。'
                                },
                                {
                                    btxt: '请注意，单独的设备信息、日志信息是无法识别特定自然人身份的个人信息。如果我们将这类非个人信息与其他个人信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。'
                                }
                            ]
                        }
                    ]
                },
                {
                    btxt: '※向您提供商品或服务',
                    tips: [
                        {
                            txt: '个人信息的分享与发布：您在使用我们的产品和服务时、上传和/或发布个人信息以及进行相关行为（例如发布提问、班群/学习群内发言、学呗打赏及课程评价）时，我们将收集您上传、发布或形成的个人信息，并有权展示您的昵称、头像和发布内容。'
                        },
                        {
                            txt: '商品或服务交付：当您在我们的商品或服务中订购具体商品或服务时，我们会通过系统为您生成购买该商品或服务的订单。乐私塾部分课程服务会向您寄送随课物料，为便于向您交付商品或服务，您可能需提供收货人个人身份信息、姓名、收货地址、邮政编码、收货人、联系电话、支付状态信息。如果您拒绝提供此类个人信息，我们将无法完成相关交付服务。如您通过我们的产品和服务为其他人订购商品或服务，您需要提供该实际订购人的前述个人信息。向我们提供该实际订购人的前述个人信息之前，您需确保您已经取得其授权同意。您在使用乐私塾课程服务时，我们会记录您的学习个人信息：您当前的学习阶段、课程学习进度个人信息、测验结果、智能练习做题结果、学习时长。我们将应用这部分个人信息分析您的学习状态，为您或为我们的服务优化提供参考。'
                        },
                        {
                            txt: '为完成订单支付、交付商品或服务、确认交易状态及为您提供售后与争议解决服务，我们会通过您基于交易所选择的交易对象、支付机构、物流公司收集与交易进度相关的您的账号、订单、交易、支付、物流信息，或将您的交易信息共享给上述服务提供者。'
                        },
                        {
                            txt: '订单管理：为展示您的账户的订单个人信息及保障您的售后权益，乐私塾会收集您在使用乐私塾过程中产生的订单个人信息、交易和消费记录、虚拟财产个人信息（包括乐私塾学币）用于向您展示及便于您对订单进行管理。'
                        },
                        {
                            utxt: [
                                '客服与售后服务：',
                                '当您联系我们的客服或使用其他用户响应功能时（包括提出售中售后申请、个人信息保护投诉或建议、其他客户投诉和需求），',
                                '我们可能需要您提供必要的个人信息以匹配并核验您的用户身份，',
                                '以便保障您的账号与系统安全。',
                                '我们可能还会保存您的联系方式（您与我们联系时使用的或您向我们主动提供的其他联系方式）、您与我们的通信/通话记录和内容、与您需求相关联的其他必要信息，',
                                '以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。'
                            ]
                        },
                    ]
                },
                {
                    btxt: '※我们通过间接方式收集到的您的个人信息：',
                    tips: [
                        {
                            txt: '我们可能从关联方、第三方合作伙伴获取您授权共享的相关个人信息。我们可能从第三方获取您授权共享的账户信息（头像、昵称、登录时间）并在您同意本政策后将您的第三方账户与您的我们的产品和服务账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们将在符合相关法律法规规定，并依据与关联方或第三方合作伙伴的约定、确信其提供的个人信息来源合法的前提下，收集并使用您的这些个人信息。'
                        }
                    ]
                },
                {
                    btxt: '※向您提供商品或服务的信息展示和推送',
                    tips: [
                        {
                            txt: '为您展示和推送商品或服务',
                            tips: [
                                {
                                    btxt: '基于您向我们提供的信息、我们可能收集的信息及我们通过间接方式收集到的您的信息（包括您的浏览及搜索记录、设备信息、位置信息、订单信息、手机号码、您参与乐私塾线上或线下活动填写问卷调查上的个人信息），我们可能会基于上述一项或几项信息的结合，进行推荐算法建模、程序化广告推荐算法建模、用户行为分析及用户画像，用于提取您的浏览、搜索偏好、行为习惯、位置信息相关特征，以便向您提供更契合您需求的页面展示和推荐个性化内容。'
                                },
                                {
                                    btxt: '我们也可能基于特征标签通过电子邮件、短信、电话或其他方式向您发送营销信息，提供或推广我们或第三方的如下商品和服务：'
                                },
                                {
                                    txt: '我们及我们关联方的商品和服务，包括：在线教育服务、语言翻译服务、语音识别和语音合成类开发平台服务、智能硬件服务、云应用服务、电子商务、即时通讯服务、网上媒体服务、互动娱乐服务、社交网络服务、支付服务、应用软件和服务、数据管理软件和服务、网上广告服务及其他社交媒体、娱乐、资讯及通讯软件和服务；'
                                },
                                {
                                    txt: '及第三方商品和服务，包括：互联网服务、物流服务、银行及金融服务、娱乐、书册和其他刊物服务、网上广告服务、积分和奖励计划，以及我们认为可能与您相关的其他商品和服务。'
                                }
                            ]
                        },
                        {
                            txt: '向您发出通知。我们可能在必需时（例如当我们由于系统维护而暂停某一单项服务、变更、终止提供某一单项服务时）向您发出与服务有关的通知。',
                            tips: [
                                {
                                    txt: '如您不希望继续接收我们推送的消息，您可要求我们停止推送，例如：根据短信退订指引要求我们停止发送推广短信，或在移动端设备中进行设置，不再接收我们推送的消息；但我们依法律规定或服务协议约定发送消息的情形除外。'
                                }
                            ]
                        }
                    ]
                },
                {
                    btxt: '※为您提供安全保障',
                    tips: [
                        {
                            txt: '为提高您使用我们及合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或我们的产品和服务相关协议规则的情况，我们可能会收集、使用或整合您的账户信息、交易信息、设备信息、日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的个人信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。'
                        }
                    ]
                },
                {
                    btxt: '※改进我们的服务',
                    tips: [
                        {
                            txt: '我们可能将通过我们的产品和服务所收集的个人信息，用于我们的其他服务：在您使用我们的产品和服务时所收集的您的个人信息，可能在我们的其他服务中用于向您提供特定内容或向您展示与您相关的、而非普遍推送的信息；我们可能让您参与有关我们的产品和服务的调查，帮助我们改善现有服务或设计新服务；同时，我们可能将您的个人信息用于软件更新。'
                        }
                    ]
                },
                {
                    btxt: '※其他用途',
                    tips: [
                        {
                            txt: '您了解并同意，在收集您的个人信息后，我们可能通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的信息，对用户数据库进行分析并予以商业化的利用，而无需另行获得您的同意。'
                        },
                        {
                            txt: '请您注意，如果我们要将您的个人信息用于本政策中未载明的其他用途或额外收集未提及的其他个人信息，我们会另行事先请您同意（确认同意的方式：勾选、弹窗、站内信、邮件、短信方式）。一旦您同意，该等额外用途将视为本政策的一部分，该等额外个人信息也将适用本政策。'
                        }
                    ]
                },
                {
                    btxt: '※征得授权同意的例外'
                },
                {
                    txt: '根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：',
                    tips: [
                        {
                            txt: '与国家安全、国防安全有关的；'
                        },
                        {
                            txt: '与与公共安全、公共卫生、重大公共利益有关的；'
                        },
                        {
                            txt: '与犯罪侦查、起诉、审判和判决执行等有关的；'
                        },
                        {
                            txt: '出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；'
                        },
                        {
                            txt: '所收集的个人信息是您自行向社会公众公开的；'
                        },
                        {
                            txt: '从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；'
                        },
                        {
                            txt: '根据您的要求签订合同所必需的；'
                        },
                        {
                            txt: '用于维护我们的产品和服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；'
                        },
                        {
                            txt: '为合法的新闻报道所必需的；'
                        },
                        {
                            txt: '学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；'
                        },
                        {
                            txt: '法律法规规定的其他情形。'
                        }
                    ]
                },
                {
                    btxt: '※您理解并同意，我们的产品和服务可能需要您在您的设备中开启特定的访问权限，以实现这些权限所涉及个人信息的收集和使用：',
                    tips: [
                        {
                            txt: '如我们访问您的位置信息，是为了根据您的位置信息为您提供更契合您需求的页面展示和产品服务；',
                        },
                        {
                            txt: '如我们访问您的摄像头，是为了使您可以使用摄像头进行扫码、拍摄，用于登录、支付、拍摄并上传图片以进行晒图评价或相应的分享、上传课程作业/资料、观看视频或用于课程直播中的互动；',
                        },
                        {
                            txt: '如我们访问您的相册，是为了使您可以实现您设备中的照片、图片或视频的取用与上传，便于您进行更换头像、发表评论/分享，上传作业；',
                        },
                        {
                            txt: '如我们访问您的麦克风，是为了使您可以实现语音作业的上传、语音评论、与客服实现语音交互以及课程直录播服务的语音教学交互功能，在这些功能中我们会收集您的录音内容以识别您的具体需求；',
                        },
                        {
                            txt: '您使用乐私塾直录播服务，会生成视频缓存文件，我们会申请访问该视频缓存文件，是为了使您更为流畅的体验我们的课程服务或为您提供课程离线观看功能；',
                        },
                        {
                            txt: '如我们获取您的应用列表权限，这是为了向您用于推送相关服务信息，包括手机厂商Push推送、特定事件提醒、个性化内容推荐;',
                        },
                        {
                            txt: '如我们获取您的推送权限，是为了向您进行上课提醒、班群的聊天提醒服务；',
                        },
                        {
                            txt: '在您开启日历权限后，我们将收集您的日历信息用于向您提供课程提醒或课程签到服务;',
                        },
                        {
                            txt: '在IOS系统下，如我们获取您的“运动与健身”权限，是为了使您能够使用完整的护眼模式功能；',
                        },
                        {
                            txt: '在IOS系统下，如我们获取您的“Face ID”权限，是为了使您实现快捷登陆；',
                        },
                    ]
                },
                {
                    btxt: '※有关个人敏感信息的提示',
                    tips: [
                        {
                            txt: '以上由您提供或我们收集您的个人信息中，可能包含您的个人敏感信息，包括银行账号、交易和消费记录、虚拟财产信息、系统账号、邮箱地址及其有关的密码、电话号码、网页浏览记录、位置信息。请您谨慎并留意个人敏感信息，您同意您的个人敏感信息我们可以按本政策所述的目的和方式来处理。'
                        }
                    ]
                }
            ]
        },
        {
            title: '二、我们如何使用COOKIES或同类技术',
            data: [
                {
                    btxt: '※Cookies'
                },
                {
                    txt: '我们或我们的第三方合作伙伴可能通过COOKIES获取和使用您的个人信息，并将该等个人信息储存为日志信息。'
                },
                {
                    txt: '通过使用COOKIES，我们向您提供简单易行并富个性化的网络体验。一个COOKIES是少量的数据，它们从一个网络服务器送至您的浏览器并存在计算机硬盘上。我们使用COOKIES是为了让您可以受益。比如，为使得乐私塾的登录过程更快捷，您可以选择把用户名存在一个COOKIES中。这样下次当您要登录乐私塾的服务时能更加方便快捷。COOKIES能帮助我们确定您连接的页面和内容，您在乐私塾特定服务上花费的时间和您所选择的我们的产品和服务。'
                },
                {
                    txt: 'COOKIES使得我们能更好、更快地为您服务，并且使您在我们的产品和服务上的经历更富个性化。然而，您应该能够控制COOKIES是否以及怎样被你的浏览器接受。请查阅您的浏览器附带的文件以获得更多这方面的个人信息。'
                },
                {
                    txt: '我们和第三方合作伙伴可能通过COOKIES收集和使用您的个人信息，并将该等个人信息储存。'
                },
                {
                    txt: '我们使用自己的COOKIES，可能用于以下用途：',
                    tips: [
                        {
                            txt: '记住您的身份。COOKIES有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供有关您的喜好或其他个人信息；'
                        },
                        {
                            txt: '分析您使用我们服务的情况。我们可利用COOKIES来了解您使用我们的产品和服务进行什么活动、或哪些服务或服务最受欢迎；'
                        },
                        {
                            txt: '广告优化。COOKIES有助于我们根据您的个人信息，向您提供与您相关的广告而非进行普遍的广告投放。'
                        }
                    ]
                },
                {
                    txt: '我们为上述目的使用COOKIES的同时，可能将通过COOKIES收集的非个人身份信息汇总提供给广告商和其他伙伴，用于分析您和其他用户如何使用我们的产品和服务并用于广告服务。'
                },
                {
                    txt: '我们的产品和服务上可能会有广告商和其他合作方放置的COOKIES。这些COOKIES可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方COOKIES收集和使用该等个人信息不受本政策约束，而是受到其自身的个人信息保护声明约束，我们不对第三方的COOKIES承担责任。'
                },
                {
                    txt: '您可以通过浏览器或用户选择机制拒绝或管理COOKIES。但请您注意，如果您停用COOKIES，我们有可能无法为您提供最佳的服务体验，某些服务也可能无法正常使用。同时，您仍然将收到广告，只是这些广告与您的相关性会降低。'
                },
                {
                    btxt: '※网站信标和像素标签',
                    tips: [
                        {
                            txt: '除 Cookies 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。'
                        }
                    ]
                }
            ]
        },
        {
            title: '三、我们可能分享、转让或披露的个人信息',
            data: [
                {
                    btxt: '※分享'
                },
                {
                    txt: '除以下情形外，未经您同意，我们不会与我们及我们的关联方之外的任何第三方分享您的个人信息：',
                    tips: [
                        {
                            txt: '向您提供我们的服务。我们可能向合作伙伴及其他第三方分享您的个人信息，以实现您需要的核心功能或提供您需要的服务，例如：向物流服务商提供对应的订单信息；'
                        },
                        {
                            txt: '维护和改善我们的服务。我们可能向合作伙伴及其他第三方分享您的个人信息，以帮助我们为您提供更有针对性、更完善的服务，例如：代表我们发出电子邮件或推送通知的通讯服务提供商；'
                        },
                        {
                            txt: '实现本政策第一条“我们如何收集和使用您的个人信息”部分所述目的；'
                        },
                        {
                            txt: '履行我们在本政策或我们与您达成的其他协议中的义务和行使我们的权利；'
                        },
                        {
                            txt: '向委托我们进行推广的合作伙伴等第三方共享，目的是为了使该等委托方了解推广的覆盖面和有效性。比如我们可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的商品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客。'
                        },
                        {
                            txt: '在法律法规允许的范围内，为了遵守法律、维护我们及我们的关联方或合作伙伴、您或其他乐私塾用户或社会公众利益、财产或安全免遭损害，比如为防止欺诈等违法活动和减少信用风险，我们可能与其他公司和组织交换个人信息。不过,这并不包括违反本政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。'
                        },
                        {
                            txt: '应您合法需求，协助处理您与他人的纠纷或争议；'
                        },
                        {
                            txt: '应您的监护人合法要求而提供您的个人信息；'
                        },
                        {
                            txt: '根据与您签署的服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；'
                        },
                        {
                            txt: '基于学术研究而提供；'
                        },
                        {
                            txt: '基于符合法律法规的社会公共利益而提供。'
                        }
                    ]
                },
                {
                    txt: '我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。'
                },
                {
                    btxt: '※转让',
                    tips: [
                        {
                            txt: '随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的个人信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意。'
                        },
                        {
                            txt: '在获得您的明确同意后，我们会向其他方转让您的个人信息。'
                        }
                    ]
                },
                {
                    btxt: '※披露'
                },
                {
                    txt: '我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的个人信息：',
                    tips: [
                        {
                            txt: '根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；'
                        },
                        {
                            txt: '根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露个人信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的个人信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。'
                        }
                    ]
                },
                {
                    btxt: '※分享、转让、披露个人信息时事先征得授权同意的例外'
                },
                {
                    txt: '以下情形中，分享、转让、披露您的个人信息无需事先征得您的授权同意：',
                    tips: [
                        {
                            txt: '与国家安全、国防安全有关的；'
                        },
                        {
                            txt: '与公共安全、公共卫生、重大公共利益有关的；'
                        },
                        {
                            txt: '与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；'
                        },
                        {
                            txt: '出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；'
                        },
                        {
                            txt: '您自行向社会公众公开的个人信息；'
                        },
                        {
                            txt: '从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。'
                        }
                    ]
                },
                {
                    txt: '根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。'
                }
            ]
        },
        {
            title: '四、我们如何保留、储存和保护您的个人信息安全',
            data: [
                {
                    txt: '我们仅在本政策所述目的所必需期间和法律法规及监管规定的时限内保存您的个人信息。如我们终止服务或运营，我们将及时停止继续收集您个人信息的活动，同时会遵守相关法律法规要求提前向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理，法律法规或监管部门另有规定的除外。'
                },
                {
                    btxt: '※我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内。以下情形除外：',
                    tips: [
                        {
                            txt: '法律法规有明确规定；'
                        },
                        {
                            txt: '获得您的授权同意；'
                        },
                        {
                            txt: '您使用的产品、服务涉及跨境，我们需要向境外提供您的个人信息的。'
                        }
                    ]
                },
                {
                    txt: '针对以上情形，我们会确保依据本政策及国家法律法规要求对您的个人信息提供足够的保护。'
                },
                {
                    btxt: '※我们非常重视个人信息安全，成立了专门的安全团队，并采取一切合理可行的措施，保护您的个人信息：',
                    tips: [
                        {
                            txt: '数据安全技术措施 ',
                            tips: [
                                {
                                    btxt: '我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。网络服务采取了多种加密技术，例如在某些服务中，我们将利用加密技术（例如SSL）来保护您的个人信息，采取加密技术对您的个人信息进行加密保存，并通过隔离技术进行隔离。 在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用多种数据脱敏技术增强个人信息在使用中的安全性。采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。'
                                }
                            ]
                        },
                        {
                            txt: '我们为保护个人信息采取的其他安全措施',
                            tips: [
                                {
                                    txt: '我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。'
                                },
                                {
                                    txt: '我们通过个人信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。'
                                },
                                {
                                    txt: '我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识和安全意识。'
                                },
                                {
                                    txt: '我们仅允许有必要知晓这些个人信息的我们及我们关联方的员工、合作伙伴访问您的个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您的个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的合作关系。'
                                },
                            ]
                        },
                        {
                            txt: '互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。'
                        },
                        {
                            txt: '我们将尽力确保或担保您发送给我们的任何个人信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致个人信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。'
                        }
                    ]
                },
                {
                    btxt: '※安全事件处置',
                    tips: [
                        {
                            txt: '在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、短信、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。'
                        },
                        {
                            txt: '请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证个人信息百分之百的安全。您需要了解，您接入我们的产品和服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。'
                        }
                    ]
                }
            ]
        },
        {
            title: '五、如何管理您的个人信息',
            data: [
                {
                    txt: '我们鼓励您更新和修改您的个人信息以使其更准确有效，也请您理解，您更正、删除、撤回授权或停止使用我们的产品和服务的决定，并不影响我们此前基于您的授权而开展的个人信息处理。除法律法规另有规定，当您更正、删除您的个人信息或申请注销账号时，我们可能不会立即从备份系统中更正或删除相应的个人信息，但会在备份更新时更正或删除这些个人信息。'
                },
                {
                    txt: '您可以通过以下方式来管理您的个人信息：'
                },
                {
                    btxt: '※访问、更正您的个人信息',
                    tips: [
                        {
                            txt: '账户个人信息：如果您希望访问或编辑您的账户中的个人基本个人信息（包括头像、昵称、收货地址、手机号），您可以登录移动客户端账号通过“我的账户”执行此类操作。'
                        },
                        {
                            txt: '搜索个人信息：您可以通过点击搜索框访问或清除您的搜索历史记录。'
                        },
                        {
                            txt: '订单个人信息：您可以通过“我的订单”查看您的所有订单状态以及通过“我的拼团”查看您的所有拼团订单个人信息。'
                        },
                        {
                            txt: '账户礼券：您可以登录移动客户端账号通过“我的账户”中“账户余额”、“我的学呗”、“我的优惠券”查看您的相关余额、积分、优惠券个人信息。'
                        }
                    ]
                },
                {
                    txt: '如果您无法通过上述路径访问、更正该等个人信息，您可以通过本政策第九条【如何联系我们】约定的联系方式与我们取得联系。对于您在使用我们的产品和服务过程中产生的其他个人信息需要访问、更正，我们会根据本政策所列明的方式、期限及范围来响应您的请求。'
                },
                {
                    btxt: '※删除您的个人信息'
                },
                {
                    txt: '您可以通过“（一）访问、更正您的个人信息”中列明的方式自主删除您的部分个人信息。在部分个人信息删除时，我们可能会要求您进行身份验证，以保障个人信息安全。'
                },
                {
                    txt: '在以下情形中，您可以向我们提出删除个人信息的请求：',
                    tips: [
                        {
                            txt: '如果我们处理个人信息的行为违反法律法规；'
                        },
                        {
                            txt: '如果我们收集、使用您的个人信息，却未征得您的授权同意；'
                        },
                        {
                            txt: '如果我们处理个人信息的行为严重违反了与您的约定；'
                        },
                        {
                            txt: '如果我们不再为您提供我们的产品和服务。'
                        }
                    ]
                },
                {
                    txt: '若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。'
                },
                {
                    btxt: '※公开与分享',
                    tips: [
                        {
                            txt: '我们的多项服务可让您不仅与您的社交网络、也与使用该服务的所有用户公开分享您的相关个人信息，例如，您在我们的产品和服务中所上传或发布的个人信息、您对其他人上传或发布的个人信息作出的回应，通过电子邮件或在我们的产品和服务中不特定用户可见的公开区域内上传或公布您的个人信息，以及包括与这些个人信息有关的位置数据和日志个人信息。只要您不删除您所公开或共享的个人信息，有关个人信息可能一直留存在公众领域；即使您删除共享个人信息，有关个人信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公众领域保存。如您将个人信息通过上述渠道公开或共享，由此造成您的个人信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑是否通过上述渠道公开或共享您的个人信息。'
                        }
                    ]
                },
                {
                    btxt: '※改变您授权同意的范围',
                    tips: [
                        {
                            txt: '您总是可以选择是否披露个人信息。有些个人信息是使用我们的产品和服务所必需的，但大多数其他个人信息的提供是由您决定的。您可以通过删除个人信息、关闭设备功能等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。'
                        },
                        {
                            txt: '当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的个人信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的个人信息处理。'
                        }
                    ]
                }
            ]
        },
        {
            title: '六、第三方服务',
            data: [
                {
                    txt: '我们的产品和服务可能链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：'
                },
                {
                    txt: '※您可利用“分享”键将某些我们的产品和服务内容分享到第三方服务，或您将第三方服务内容分享到我们的产品和服务。这些功能可能会收集您的信息（包括您的日志信息），并可能在您的电脑装置COOKIES，从而正常运行上述功能；'
                },
                {
                    txt: '※我们通过广告或我们服务的其他方式向您提供链接，使您可以链接至第三方的服务或网站；'
                },
                {
                    txt: '※其他接入第三方服务的情形。为实现本政策中声明的目的，我们可能会接入第三方服务商提供的SDK或其他类似的应用程序，并将我们依照本政策收集的您的某些信息共享给该等第三方服务商，以便提供更好的客户服务和用户体验。目前，我们接入的第三方服务商主要包括以下几种类型：',
                    tips: [
                        {
                            txt: '第三方SDK“小米”、“华为”,用于推送相关服务信息，包括手机厂商Push推送、特定事件提醒、个性化内容推荐,需要获取您的设备信息；'
                        },
                        {
                            txt: '第三方SDK“易盾”，用于实现一键登录功能以及接收注册和登陆的验证码服务，在此功能下，我们可能将您的设备信息通过易盾发送给您手机号所属的中国移动、中国联通及中国电信运营商；'
                        },
                        {
                            txt: '第三方SDK“华为支付”、”微信支付”、“支付宝”用于支付相关服务及汇总/统计支付信息：包括订单支付、交易行为核验、收入结算、支付信息汇总统计，需要获取您的设备信息；'
                        },
                        {
                            txt: '第三方SDK“高德地图”为了确认您所在学校，需要在您同意的情况下获取设备位置权限、搜集设备信息和日志信息；'
                        },
                        {
                            txt: '第三方SDK“腾讯微信”、“腾讯QQ”、“新浪微博”，为了用于第三方授权服务，包括第三方账号登陆、将相关内容分享至第三方产品，需要获取您的设备信息；'
                        },
                        {
                            txt: '第三方SDK“朗和科技”、“拓思德”、“七鱼”，为了用于支持产品功能模块，包括语音识别、在线直播、视频播放、连接智能硬件、客服，需要获取您的设备信息；'
                        },
                        {
                            txt: '第三方SDK“友盟”、谷歌“Firebase”， 用于优化产品性能，包括统计数据崩溃信息，需要获取您的设备信息;'
                        },
                        {
                            txt: '第三方SDK“声通”，用于接收用户的口语跟读，运用口语评测引擎，给用户的跟读进行评分，需要获取您的设备信息。'
                        }
                    ]
                },
                {
                    txt: '如上所述服务由相关的第三方负责运营。您使用该等第三方服务（包括您向该等第三方提供的任何个人信息），须受第三方自己的服务条款及个人信息保护声明（而非本政策）约束，您需要仔细阅读其条款。我们仅会出于正当、必要、特定的目的共享您的信息。我们会要求他们履行相关保密义务并采取相应的安全措施。'
                }
            ]
        },
      ]
    }
  },
  methods: {
    handleTxt() {
        // return
    }
  },
}
</script>
<style lang="less" scoped>
.wrap {
  font-family: 宋体;
  h3 {
    margin: 20px 0;
    font-size: 20px;
    color: #000;
    text-align: left;
    text-indent: 1em;
    font-weight: bold;
  }
  p {
    font-size: 16px;
    color: #333333;
    margin: 5px 0;
  }
  a {
    color: #000;
  }
  .normal {
    text-align: left;
    text-indent: 2em;
    -ms-layout-grid-mode: char;
  }
  .sub_norma {
    text-align: left;
    text-indent: 3em;
    -ms-layout-grid-mode: char;
    .sub_norma_tip {
      display: block;
      text-indent: 4em;
    }
  }
}
</style>
